/** @format */

import { TTranslation, useAppTranslation } from '@/i18n/declarations';
import React, { FunctionComponent as FC } from 'react';
import { TabInfoWrapper } from './index.style';
import { Tab } from './types';

export const TabInfo: FC<{ activeTab: Tab; currentIndex?: number; totalPictures: number }> = ({
  activeTab,
  currentIndex,
  totalPictures,
}) => {
  const { t } = useAppTranslation();

  return (
    <TabInfoWrapper>
      <p className="title">
        {activeTab === 'videos' && t('plp.card.modal.info.videos' as TTranslation)}
        {activeTab === 'gallery' && t('plp.card.modal.info.gallery' as TTranslation)}
        {activeTab === 'vr' && t('plp.card.modal.info.vr' as TTranslation)}
        {activeTab === 'map' && t('plp.card.modal.info.map' as TTranslation)}
        {activeTab === 'planimetry' && t('plp.card.modal.info.planimetry' as TTranslation)}
      </p>
      {(activeTab === 'videos' || activeTab === 'gallery' || activeTab === 'planimetry') && (
        <p className="info">
          {activeTab === 'planimetry' && <></>}
          {activeTab === 'videos' && <></>}
          {activeTab === 'gallery' && (
            <>
              {currentIndex}/{totalPictures}
            </>
          )}
        </p>
      )}
    </TabInfoWrapper>
  );
};
